import React, { useMemo, useState, useEffect } from "react";

import PanelLayout from "components/base/PanelLayout";
import PageHeader from "components/base/PageHeader";
import AccountManagersCreateForm from "./AccountManagersCreateForm";
import AccountManagersFilter from "./AccountManagersFilter";
import AccountManagersTable from "./AccountManagersTable";
import { useDebounce, useWindowWidth } from "hooks";


export default ({
    managersList,
    loading,
    teamLeadList,
    userList,
    billingList,
    getAccountManagersList,
    getAccountManagersReferences,
    getAccountManagersBillingList,
    createAccountManager,
    modifyAccountManager,
    removeAccountManager,
}) => {
    const [filters, setFilters] = useState({
        str: "",
        show_only_active: true,
    });
    // const debouncedSearch = useDebounce(filters.str, 300);
    const windowWidth = useWindowWidth();
    const isMobile = windowWidth < 768;

    useEffect(() => {
        getAccountManagersList();
        getAccountManagersReferences();
        getAccountManagersBillingList();
    }, []);

    const filteredData = useMemo(() => {
        return managersList.filter(item => {
            if (filters.show_only_active && !item.active) {
                return false;
            }

            if (filters.str) {
                const searchStr = filters.str.toLowerCase();
                const teamLead = teamLeadList.find(teamLead => teamLead.account_user_id === item?.account_user_teamlead?.account_user_id);
                const billing = billingList.find(billing => billing.ACM_KEY === item.billing_acm_key);
                const accUserManagerIdList = item?.account_user_manager_list?.map(manager => manager.account_user_id) || [];
                const managerUsers = userList.filter(user => accUserManagerIdList.includes(user.account_user_id));
                const managerUserNames = managerUsers.map(user => `${user.account_user_name} ${user.account_user_surname}`.toLowerCase());
                const managerUserEmails = managerUsers.map(user => user.account_user_email.toLowerCase());

                const hasSearchStr = item?.name?.toLowerCase()?.includes(searchStr)
                    || item?.email?.toLowerCase()?.includes(searchStr)
                    || (teamLead && teamLead?.account_user_email && teamLead.account_user_email.toLowerCase().includes(searchStr))
                    || (teamLead && `${teamLead.account_user_name} ${teamLead.account_user_surname}`.toLowerCase().includes(searchStr))
                    || (billing && billing.ACM_NAME.toLowerCase().includes(searchStr))
                    || managerUserNames.some(name => name.includes(searchStr))
                    || managerUserEmails.some(email => email.includes(searchStr));

                return hasSearchStr;
            }

            return true;
        });
    }, [filters.show_only_active, filters.str, managersList, teamLeadList, userList, billingList]);

    const advanceTeamLeadList = makeAdvancedAccountUserList(teamLeadList);

    const advanceUserManagerList = makeAdvancedAccountUserList(userList);

    return (
        <PanelLayout>
            <PageHeader extraTitle="Account Managers" />
            <AccountManagersFilter
                filters={filters}
                setFilters={setFilters}
                isMobile={isMobile}
            />
            <AccountManagersTable
                data={filteredData}
                {...{
                    loading,
                    teamLeadList: advanceTeamLeadList,
                    userList: advanceUserManagerList,
                    billingList,
                    modifyAccountManager,
                    removeAccountManager,
                    getAccountManagersList,
                }}
            />
            <AccountManagersCreateForm
                onSubmit={createAccountManager}
                {...{
                    managersList,
                    billingList,
                    teamLeadList: advanceTeamLeadList,
                    userList: advanceUserManagerList,
                    getAccountManagersList,
                }}
            />
        </PanelLayout>
    );
};

const makeAdvancedAccountUserList = (list) => {
    return list.map(value => {
        const name = value?.account_user_surname ? `${value.account_user_name} ${value.account_user_surname}` : value.account_user_name;
        return {
            id: value.account_user_id,
            name
        }
    });
};